import moment from "moment";
import fileSys from "../../fileoprators/fileSystem";
import { FILES, INVALID_1000, hasKey } from "../shared";
import { iniReader } from "./iniReaderWriter";
import TopographyProc from "./TopographyRecordProc";
import { isDefined, isStringEmpty, json2string } from "../../shared/utils";
import CalCaseDebug from "./CalCaseDebug";

const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));

function getRecordImg(caseFolder) {
  let orgPath = fileSys.combinePath(caseFolder, FILES.originImageTh);
  let shotInfoPath = fileSys.combinePath(caseFolder, FILES.shotJson);
  let objShotInfo = fileSys.readJsonFile(shotInfoPath);
  let objCalib = iniReader(fileSys.getCalibPath(FILES.calib)) || {};
  let centerCamCalib = objCalib.CenterCamCalib || {};

  if (
    fileSys.isFileExists(orgPath) &&
    objShotInfo &&
    objShotInfo.shotInfo &&
    objShotInfo.shotInfo.shotMode &&
    centerCamCalib
  ) {
    if (
      (objShotInfo.shotInfo.shotMode === "near" && !centerCamCalib.toponear) ||
      (objShotInfo.shotInfo.shotMode === "far" && !centerCamCalib.topofar)
    ) {
      return {};
    }
    let pixelsize = parseFloat(
      objShotInfo.shotInfo.shotMode === "near" ? centerCamCalib.toponear : centerCamCalib.topofar
    );
    let data = fileSys.readFile(orgPath, null, true);
    data = data.toString("base64");
    return {
      size_x: 2048 * pixelsize,
      size_y: 1536 * pixelsize,
      b64: data
    };
  } else {
    return {};
  }
}

function getRecordKeratometry(caseFolder) {
  const iniPath = fileSys.combinePath(caseFolder, FILES.acdotana);
  let dataParams = iniReader(iniPath) || {};
  let corneaFront = dataParams.CorneaFront || {};

  return {
    flat_roc: corneaFront.Rf,
    steep_roc: corneaFront.Rs,
    flat_axis: corneaFront.AxisFlat
  };
}
function getRecordData(caseFolder) {
  let arrData = [];
  let matsize = 121;
  let len = matsize * matsize;
  let outx = new Float64Array(len);
  let outy = new Float64Array(len);
  let outz = new Float64Array(len);
  outx.fill(INVALID_1000);
  outy.fill(INVALID_1000);
  outz.fill(INVALID_1000);

  let result = addonDT.ExportHeightDatainTriplet(
    fileSys.combinePath(caseFolder, FILES.cartCrnf),
    fileSys.combinePath(caseFolder, FILES.cartFlgf),
    outx.buffer,
    outy.buffer,
    outz.buffer,
    matsize
  );

  if (result) {
    for (let i = 0; i < len; i++) {
      if (outx[i] === INVALID_1000 || outy[i] === INVALID_1000 || outz[i] === INVALID_1000) {
        continue;
      }
      arrData.push([outx[i]._toFixed(1), outy[i]._toFixed(1), outz[i]._toFixed(2)]);
    }
  }

  return arrData;
}

function getCTRecord(record, caseFolder, eyeType) {
  return {
    type: `corneal_height_mm_${eyeType === "OS" ? "l" : "r"}e`,
    capture_date: moment(record.recorddate).format("YYYY-MM-DD--HH--mm"),
    img: getRecordImg(caseFolder),
    keratometry: getRecordKeratometry(caseFolder),
    data: getRecordData(caseFolder)
  };
}

// export function getCTEyePatientObj (patient) {
//   var obj = {
//     header: 'TTF',
//     file_version: '2.2',
//     dob: patient.birthday || '',
//     lastname: patient.lastname || '',
//     firstname: patient.firstname || '',
//     sex: patient.sex === 'F' ? 'Female' : (patient.sex === 'M' ? 'Male' : ''),
//     device: 'medmont_e300',
//     data_sets: []
//   }
//   return obj
// }
// export function getCTEyeRecordsObj (records) {
//   return new Promise(async (resolve, reject) => {
//     let validRecords = getCTRecords(records)
//     let dataSets = []
//     let topographyRecordProc = new TopographyProc()
//     for (let i = 0; i < validRecords.length; i++) {
//       let casePath = await topographyRecordProc.getRecord(validRecords[i], validRecords[i].eyetype)
//       dataSets.push(getRecordJson(validRecords[i], casePath))
//     }
//     resolve(dataSets)
//   })
// }
function combineEye(objPatient, objRecords) {
  if (!objPatient) {
    return null;
  }

  let obj = JSON.parse(JSON.stringify(objPatient));
  obj.data_sets = objRecords || [];

  return obj;
}
function getFullName(patient) {
  if (isDefined(patient)) {
    if (isDefined(patient.lastname) && !isStringEmpty(patient.lastname)) {
      return `${patient.firstname}_${patient.lastname}`;
    } else {
      return patient.firstname;
    }
  }
  return "";
}

function getPatient(patient) {
  let sex = patient.sexdb || patient.sex || "";
  let obj = {
    header: "TTF",
    file_version: "2.2",
    dob: patient.birthday || "",
    lastname: patient.lastname || "",
    firstname: patient.firstname || "",
    sex: sex === "F" ? "Female" : sex === "M" ? "Male" : "NA",
    device: "Dea520"
  };
  return obj;
}
class ExportEyeJson {
  constructor() {
    this.objPatient = null;
    this.objRecords = null;
    this._patientId = null;
  }
  addCTRecord(patient, record, caseFolder, eyeType) {
    if (!this.objPatient || this._patientId !== patient._id) {
      this.objPatient = getPatient(patient);
      this.objRecords = [];
    }
    this._patientId = patient._id;
    this.objRecords = this.objRecords || [];
    this.objRecords.push(getCTRecord(record, caseFolder, eyeType));
  }
  get() {
    let obj = combineEye(this.objPatient, this.objRecords);
    return obj;
  }
  save(patient, rootpath) {
    let obj = combineEye(this.objPatient, this.objRecords);
    let json = json2string(obj);
    let jsonpath = `${rootpath}/${getFullName(patient)}.eye`;
    fileSys.mkdirSync(rootpath);
    fileSys.writeFileSync(jsonpath, json);
  }
}
export default ExportEyeJson;



// WEBPACK FOOTER //
// ./src/topography/js/exportEyeJson.js